<template>
  <ATooltip v-if="tooltip" placement="top" :delay="{ show: 50, hide: 0 }">
    <span
      class="code-occurrence-bubble"
      :class="{ 'code-occurrence-bubble--tooltip': tooltip }"
      data-test-id="code-occurrence-bubble"
    >
      {{ occurrence }}
    </span>

    <template #popper>
      {{ tooltip }}
    </template>
  </ATooltip>
  <span v-else class="code-occurrence-bubble" data-test-id="code-occurrence-bubble">
    {{ occurrence }}
  </span>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CodeOccurrenceBubble',

  props: {
    occurrence: {
      type: Number,
      required: true,
    },
    tooltip: {
      type: String,
      default: null,
    },
  },
});
</script>
<style lang="scss">
@use 'settings/colors';
@use 'mixins/typography';

.code-occurrence-bubble {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 4px;
  border-radius: 50%;
  background-color: colors.$color-grey-50;
  color: colors.$color-grey-800;
  @include typography.typography-10-medium(10px);

  &.code-occurrence-bubble--tooltip {
    &:hover {
      background-color: colors.$color-blue-100;
    }
  }
}
</style>
